let store: any | null = null;

function getStore() {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (!process.env.REACT_SSR) {
		return null;
	}

	const AsyncLocalStorage = (globalThis as any)?.__vm_internals__?.asyncLocalStorage
		?.AsyncLocalStorage;

	if (!AsyncLocalStorage) {
		/* eslint-disable no-console */
		console.error(
			`AsyncLocalStorage is not available. __vm_internals__: ${JSON.stringify(
				Object.keys((globalThis as any)?.__vm_internals__ || {}),
			)}`,
		);
		return null;
	}
	if (!store) {
		store = new AsyncLocalStorage();
	}
	return store;
}

export function runInQueryBoundary(name: string, callback: () => void) {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (!process.env.REACT_SSR) {
		return callback();
	}

	const store = getStore();
	if (!store) {
		return callback();
	}
	return store.run(name, callback);
}

export function getQueryBoundary(): string | null {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (!process.env.REACT_SSR) {
		return null;
	}

	const store = getStore();
	if (!store) {
		return null;
	}
	return store.getStore();
}
